// FactStamp — synlig datering och attribution för sidor med siffror.
//
// Svarsmotorer citerar det som är daterat, attribuerat och siffersatt.
// Prissidorna hade siffrorna men varken datum, avsändare eller underlag
// synligt för användaren. Datumet och underlaget kommer från
// src/content/pricing-facts.ts så stämpeln aldrig kan säga något annat
// än prisdatan själv.

import { Link } from "@tanstack/react-router";
import { PRICE_DATA_BASIS } from "@/content/pricing-facts";
import { EDITORIAL_POLICY_PATH, authorPath } from "@/content/editorial";

const fmt = (iso: string) =>
  new Date(iso).toLocaleDateString("sv-SE", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

export function FactStamp({
  reviewed = PRICE_DATA_BASIS.reviewed,
  basis = PRICE_DATA_BASIS.sourceSentence,
  className = "",
}: {
  reviewed?: string;
  basis?: string;
  className?: string;
}) {
  return (
    <aside
      className={`mx-auto max-w-3xl rounded-lg border border-border/70 bg-surface/40 px-4 py-3 text-xs leading-relaxed text-muted-foreground ${className}`}
    >
      <p>
        <strong className="font-medium text-foreground/80">
          Senast granskad {fmt(reviewed)}
        </strong>{" "}
        av{" "}
        <Link to={authorPath("mattias")} className="underline underline-offset-2">
          {PRICE_DATA_BASIS.reviewer}
        </Link>
        , ansvarig utgivare.
      </p>
      <p className="mt-1">{basis}</p>
      <p className="mt-1">
        <Link to={EDITORIAL_POLICY_PATH} className="underline underline-offset-2">
          Så granskar vi fakta
        </Link>
      </p>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Dataset",
            name: "Fennys prisdata för filmproduktion",
            description: basis,
            dateModified: reviewed,
            creator: { "@id": "https://fenny.se/redaktionen/mattias#person" },
            publisher: { "@id": "https://fenny.se/#organization" },
            variableMeasured: "Prisspann per filmformat, exkl. moms",
            measurementTechnique: `Sammanställning av ${PRICE_DATA_BASIS.sampleSize} egna offerter och genomförda produktioner`,
          }),
        }}
      />
    </aside>
  );
}
